import { render, staticRenderFns } from "./CustomerChatSheet.vue?vue&type=template&id=ad245356&scoped=true"
import script from "./CustomerChatSheet.vue?vue&type=script&lang=js"
export * from "./CustomerChatSheet.vue?vue&type=script&lang=js"
import style0 from "./CustomerChatSheet.vue?vue&type=style&index=0&id=ad245356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad245356",
  null
  
)

export default component.exports